import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabset-card-w-count',
  templateUrl: './tabset-card-w-count.component.html',
  styleUrls: ['./tabset-card-w-count.component.scss']
})
export class TabsetCardWCountComponent implements OnInit {

  constructor(private elementRef: ElementRef) { }

  @Input() count: number;

  @Input() cardName: string;

  @Input() color: string;

  @Input() icon: string;

  ngOnInit() {



  }

  ngAfterViewInit() {

    switch (this.color) {
      case 'red':
        this.setColorProperty('rgb(119,136,153)', 'rgb(119,136,153)', 'rgb(119,136,153)', 'rgb(119,136,153)', 'rgb(119,136,153)');
        break;

      case 'dark-blue':
        this.setColorProperty('rgb(0,138,216)', 'rgb(0, 0, 230)', 'rgb(0, 0, 255)', 'rgb(0, 0, 255)', 'rgb(32,178,170)');
        break;

      case 'light-green':
        this.setColorProperty('rgb(0, 179, 0)', 'rgb(0, 128, 0)', 'rgb(0, 210, 0)', 'rgb(0, 210, 0)', 'rgb(189, 220, 0)');
        break;

      case 'dark-green':
        this.setColorProperty('rgb(25, 102, 25)', 'rgb(0, 77, 0)', 'rgb(0, 128, 0)', 'rgb(0, 128, 0)', 'rgb(240,128,128)');
        break;

      case 'pink':
        this.setColorProperty('rgb(255, 102, 128)', 'rgb(255, 77, 106)', 'rgb(255, 77, 106)', 'rgb(255, 77, 106)', 'rgb(148, 53, 119)');
        break;

      case 'violet':
        this.setColorProperty('rgb(231, 75, 231)', 'rgb(227, 53, 227)', 'rgb(224, 31, 224)', 'rgb(224, 31, 224)', 'rgb(220,20,60)');
        break;

      case 'orange':
        this.setColorProperty('rgb(160,82,45)', 'rgb(160,82,45)', 'rgb(160,82,45)', 'rgb(160,82,45)', 'rgb(160,82,45)');
        break;

      case 'cyan':
        this.setColorProperty('rgb	(95,158,160)', 'rgb(95,158,160)', 'rgb(95,158,160)', 'rgb(95,158,160)', 'rgb(95,158,160)');
        break;




    }

  }

  setColorProperty(mainColor, secondaryColor, counterColor, borderColor, textColor) {

    this.elementRef.nativeElement.style.setProperty('--main-color', mainColor);
    this.elementRef.nativeElement.style.setProperty('--secondary-color', secondaryColor);
    this.elementRef.nativeElement.style.setProperty('--counter-color', counterColor);
    this.elementRef.nativeElement.style.setProperty('--border-color', borderColor);
    this.elementRef.nativeElement.style.setProperty('--text-color', textColor);

  }

}
